import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Table from "../../../core/common/dataTable/index";
import { getNocSapLogData } from "../../../core/data/redux/nocSapLogsSlice";
import { all_routes } from "../../router/all_routes";
import { formatEmpIdForDisplay } from "../../../utils/empIdUtils";
import { formatDateTime } from "../../../utils/dateUtils";

const NocSapLogs = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const nocSapLogState = useSelector((state: any) => state.nocSapLogState);

  const [dataList, setDataList] = useState<any[]>([]);
  const [query, setQuery] = useState<string>("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  const fetchRecords = (pagination: any, query: string) => {
    dispatch(
      getNocSapLogData({
        page: pagination.current,
        limit: pagination.pageSize,
      })
    );
  };

  const handleRefresh = () => {
    // Reset any previous state and fetch fresh data
    console.log("Refreshing OTP logs...");
    fetchRecords(pagination, query);
  };

  const handlePagination = (paginationEvent: any) => {
    const newPagination = {
      current: paginationEvent.current,
      pageSize: paginationEvent.pageSize,
      total: pagination.total, // Keep existing total
    };
    setPagination(newPagination);
    fetchRecords(newPagination, query);
  };

  const handleSearch = (searchQuery: string) => {
    setQuery(searchQuery);
    // Reset to page 1 when searching
    const resetPagination = {
      ...pagination,
      current: 1,
    };
    setPagination(resetPagination);
    fetchRecords(resetPagination, searchQuery);
  };

  useEffect(() => {
    fetchRecords(pagination, query);
  }, []);

  useEffect(() => {
    if (
      nocSapLogState.loading === "fulfilled" &&
      nocSapLogState.action === "list"
    ) {
      console.log("OTP logs fetched successfully:", nocSapLogState);
      setDataList(nocSapLogState.data?.data?.data || []);
      setPagination((prev) => ({
        ...prev,
        total: nocSapLogState.data?.data?.total || 0,
        pageSize: nocSapLogState.data?.data?.limit || prev.pageSize,
      }));
    } else if (nocSapLogState.loading === "rejected") {
      console.error("Error fetching OTP logs:", nocSapLogState?.error);
      toast.error(nocSapLogState?.error || "Failed to fetch OTP logs");
    }
  }, [nocSapLogState.loading, nocSapLogState.action]);

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <div>
            {pagination.current
              ? index +
              pagination.current * pagination.pageSize -
              pagination.pageSize +
              1
              : index + 1}
          </div>
        </>
      ),
      sorter: (a: any, b: any) => a.id.length - b.id.length,
    },
    // {
    //   title: "EmpId",
    //   dataIndex: "empId",
    //   render: (empId: string) => <span>{formatEmpIdForDisplay(empId)}</span>,
    // },
    {
      title: "Noc Type",
      dataIndex: "noc_type",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Payload",
      dataIndex: "payload",
      width: 400,
      render: (text: any) => (
        <pre
          style={{
            backgroundColor: "#d4edda",
            padding: "8px 12px",
            borderRadius: "8px",
            maxHeight: "200px",
            minHeight: "200px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontSize: "12px",
            color: "#155724"
          }}
        >
          {typeof text === "object"
            ? JSON.stringify(text, null, 2)
            : (() => {
              try {
                return JSON.stringify(JSON.parse(text), null, 2);
              } catch {
                return text || "";
              }
            })()}
        </pre>
      ),
    },
    {
      title: "Response",
      dataIndex: "response",
      width: 400,
      render: (text: any) => {

        let jsonres: any = null;
        if (typeof text === "object") {
          jsonres = text;
        } else if (text) {
          try {
            jsonres = JSON.parse(text);
          } catch (e) {
            console.error("Invalid JSON:", e);
            jsonres = null; // or handle as needed
          }
        }
        // const jsonres = (typeof text === "object")?text:JSON.parse(JSON.stringify(text));

        return (<pre
          style={{
            backgroundColor: (jsonres?.success && jsonres?.data?.Action == 'V') ? "#d4edda" : (jsonres?.ReferenceNumber || jsonres?.data?.ReferenceNumber) ? "#d4edda" : "#f8d7da",
            padding: "8px 12px",
            borderRadius: "8px",
            maxHeight: "200px",
            minHeight: "200px",
            overflowY: "auto",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontSize: "12px",
            color: (jsonres?.success && jsonres?.data?.Action == 'V') ? "#155724" : (jsonres?.ReferenceNumber || jsonres?.data?.ReferenceNumber) ? "#155724" : "#721c24",
          }}
        >
          {typeof text === "object"
            ? JSON.stringify(text, null, 2)
            : (() => {
              try {
                return JSON.stringify(JSON.parse(text), null, 2);
              } catch {
                return text || "";
              }
            })()}

        </pre>
        )
      },
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      render: (text: string) => <span>{formatDateTime(text)}</span>,
    },


  ];

  return (
    <>
      <style>
        {`
          .spin {
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Noc Sap Logs</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Logs</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Noc Sap Logs
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="mb-2">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  onClick={handleRefresh}
                  disabled={nocSapLogState.loading === "pending"}
                  title="Refresh OTP Logs"
                >
                  <i
                    className={`ti ti-refresh me-2 ${nocSapLogState.loading === "pending" ? "spin" : ""
                      }`}
                  />
                  {nocSapLogState.loading === "pending"
                    ? "Refreshing..."
                    : "Refresh"}
                </button>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-4 mt-3"> Noc Sap Logs</h4>
            </div>
            <div className="card-body p-0 py-3">
              <Table
                columns={columns}
                dataSource={dataList}
                Selection={false}
                paginationConfig={pagination}
                handlePagination={handlePagination}
                loading={
                  nocSapLogState.loading === "pending" &&
                  nocSapLogState.action === "list"
                }
                handleSearch={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NocSapLogs;
